import { render, staticRenderFns } from "./TabDetailsInvoiceAp.vue?vue&type=template&id=aea20a1c&"
import script from "./TabDetailsInvoiceAp.vue?vue&type=script&lang=ts&"
export * from "./TabDetailsInvoiceAp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aea20a1c')) {
      api.createRecord('aea20a1c', component.options)
    } else {
      api.reload('aea20a1c', component.options)
    }
    module.hot.accept("./TabDetailsInvoiceAp.vue?vue&type=template&id=aea20a1c&", function () {
      api.rerender('aea20a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-payables/invoices-ap/TabDetailsInvoiceAp.vue"
export default component.exports